import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=341c865b&scoped=true"
import script from "./MainWrapper.vue?vue&type=script&lang=js"
export * from "./MainWrapper.vue?vue&type=script&lang=js"
import style0 from "./MainWrapper.vue?vue&type=style&index=0&id=341c865b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341c865b",
  null
  
)

export default component.exports